import { Button, Image } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import shopifyLogo from '@/assets/icons/platforms/shopify.svg';
import { Alert } from '@/components/ui/alert';
import ShopifyStoreUrlModal from '@/components/integrations/ShopifyStoreUrlModal';

/**
 * No store connected: say so, and offer the connection on the spot rather than
 * sending the brand to the integrations page and away from what it was doing.
 * Each caller names what the store is needed for.
 */
export function FlowShopifyNotConnected({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) {
  const { t } = useTranslation();
  const [isConnecting, setConnecting] = useState(false);

  return (
    <>
      <Alert
        status="warning"
        variant="surface"
        alignItems="center"
        icon={<Image src={shopifyLogo} alt="" boxSize="22px" />}
        title={
          title ??
          t('flows.properties.gift.notConnected', 'Connect your Shopify store to select products.')
        }
        children={description}
        endElement={
          <Button size="sm" variant="outline" bg="white" onClick={() => setConnecting(true)}>
            {t('flows.properties.gift.connectShopify', 'Connect Shopify')}
          </Button>
        }
      />
      <ShopifyStoreUrlModal isOpen={isConnecting} onClose={() => setConnecting(false)} />
    </>
  );
}
